import React, { useEffect, useRef, useState } from 'react'
import { IconArrowBottom, IconFilterSetting } from '../icons/Icons'

const DropdownFilter = ({ children, width }) => {
    const [toggle, setToggle] = useState(false)
    const dropdownRef = useRef(null);

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const handleToggle = () => {
        setToggle(!toggle)
    }

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setToggle(false);
        }
    };

    return (
        <div className='relative' ref={dropdownRef}>
            <button
                className={`text-primary border border-primary hover:bg-primary hover:text-white transition-colors duration-300 focus:outline-none font-light rounded-md text-sm px-4 py-1 text-center inline-flex items-center gap-1 ${toggle && "bg-primary text-white"}`}
                type="button"
                onClick={() => handleToggle()}
            >
                <IconFilterSetting className="w-4" />
                Filtros
                <IconArrowBottom className="w-1.5 h-1.5" />
            </button>

            <div className={`z-10 ${width} bg-white p-1 rounded-lg shadow-xl absolute ${!toggle && "hidden"}`}>
                {children}
            </div>
        </div>
    )
}

export default DropdownFilter